/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_HeaderInputs */

const en_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const fr_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

const it_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione`)
};

const ru_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действие`)
};

const es_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const zh_cn2_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_options_pedal_action_header = /** @type {(inputs: Options_Pedal_Action_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Options_Pedal_Action_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_header = /** @type {((inputs?: Options_Pedal_Action_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_header(inputs)
	if (locale === "de") return de_options_pedal_action_header(inputs)
	if (locale === "it") return it_options_pedal_action_header(inputs)
	if (locale === "ru") return ru_options_pedal_action_header(inputs)
	if (locale === "es") return es_options_pedal_action_header(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_header(inputs)
	if (locale === "ja") return ja_options_pedal_action_header(inputs)
	if (locale === "hi") return hi_options_pedal_action_header(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_header(inputs)
	return en_options_pedal_action_header(inputs)
});